import type { Stats } from './stats';

type Currency = Stats['currency'];

/** Same text as the kit's Money component, for chart tooltips and tables that need a string. */
export const moneyFormatter = (lang: string, { symbol, symbolPosition }: Currency) => {
    const nf = new Intl.NumberFormat(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (n: number): string => (symbolPosition === 'before' ? `${symbol}${nf.format(n)}` : `${nf.format(n)}\u00a0${symbol}`);
};

/** Compact money for an axis: no decimals. */
export const tickMoneyFormatter = (lang: string, { symbol, symbolPosition }: Currency) => {
    const nf = new Intl.NumberFormat(lang, { maximumFractionDigits: 0 });
    return (n: number): string => (symbolPosition === 'before' ? `${symbol}${nf.format(n)}` : `${nf.format(n)}\u00a0${symbol}`);
};

/** Seconds as "45 s" or "4 min" (locale units). */
export const durationFormatter = (lang: string) => {
    const minute = new Intl.NumberFormat(lang, { style: 'unit', unit: 'minute', unitDisplay: 'short', maximumFractionDigits: 1 });
    const second = new Intl.NumberFormat(lang, { style: 'unit', unit: 'second', unitDisplay: 'short', maximumFractionDigits: 0 });
    return (seconds: number): string => (seconds < 60 ? second.format(Math.round(seconds)) : minute.format(seconds / 60));
};

/** A calendar day (YYYY-MM-DD) in the user's language; days carry no time zone of their own. */
export const dayFormatter = (lang: string, options: Intl.DateTimeFormatOptions) => {
    const f = new Intl.DateTimeFormat(lang, { ...options, timeZone: 'UTC' });
    return (day: string): string => f.format(new Date(`${day}T00:00:00Z`));
};
